import api from './api';
import jwt_decode from 'jwt-decode';

export const login = async (username, password) => {
  const response = await api.post('/auth/login', { username, password });
  localStorage.setItem('token', response.data.token);
  return jwt_decode(response.data.token);
};

export const getCurrentUser = async () => {
  const response = await api.get('/auth/me');
  return response.data.data;
};

export const logout = () => {
  localStorage.removeItem('token');
};